module.exports = __webpack_public_path__ + "img/r5.9656fab0.jpg";